
//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'

//共用
import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'

import { Data as PFuturesTraderContent } from './api/pFuturesTrader/index'
import { Data as SpotTraderContent } from './api/spotTrader/index'



let aaa = JSON.stringify(OtherContent)
aaa = aaa.replaceAll("/market/<listenKey>", "/market?listenKey==")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=", "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")

const ROOT_MODULE = "zh-tw/copyTrade"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}
export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket 文檔",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}

const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}

const PFuturesTrader = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trader-pFutures-interface.html`,
  "name": "U本位合約交易員",
  "content": PFuturesTraderContent
}
const SpotTrader = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trader-spot-interface.html`,
  "name": "現貨交易員",
  "content": SpotTraderContent
}



export const copyTradeConfig = [
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  PFuturesTrader,
  SpotTrader
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/copyTrade/index.js